import toastr from 'toastr';

/* eslint-disable no-undef */

class FlashToastr {
  static display() {
    if (FLASH === undefined) return;

    Object.keys(FLASH)
      .forEach((type) => {
        switch (type) {
          case 'notice', 'success':
            toastr.success(FLASH[type]);
            break;

          case 'alert':
            toastr.error(FLASH[type]);
            break;

          case 'warning':
            toastr.warning(FLASH[type])

          default:
            toastr.info(FLASH[type]);
            break;
        }
      });
  }
}

/* eslint-enable no-undef */

export default FlashToastr;
